import type { SetState } from '../store';

export type AccountHubModalsSliceProps = {
    accountHubModals: {
        accountHub: {
            isOpen: boolean;
            setIsOpen: (isOpen: boolean) => void;
        };
        deposit: {
            isOpen: boolean;
            setIsOpen: (isOpen: boolean) => void;
        };
    };
};

export const accountHubModalsSlice = ({ set }: SetState<AccountHubModalsSliceProps>): AccountHubModalsSliceProps => ({
    accountHubModals: {
        accountHub: {
            isOpen: false,
            setIsOpen: (isOpen: boolean) => {
                set(
                    (state) => ({
                        accountHubModals: {
                            ...state.accountHubModals,
                            accountHub: { ...state.accountHubModals.accountHub, isOpen }
                        }
                    }),
                    undefined,
                    `accountHubModals/accountHub/${isOpen ? 'open' : 'close'}`
                );
            }
        },
        deposit: {
            isOpen: false,
            setIsOpen: (isOpen: boolean) => {
                set(
                    (state) => ({
                        accountHubModals: {
                            ...state.accountHubModals,
                            deposit: { ...state.accountHubModals.deposit, isOpen }
                        }
                    }),
                    undefined,
                    `accountHubModals/deposit/${isOpen ? 'open' : 'close'}`
                );
            }
        }
    }
});
